import { render } from "./app-layout-setting.vue?vue&type=template&id=ca270332"
import script from "./app-layout-setting.vue?vue&type=script&lang=js"
export * from "./app-layout-setting.vue?vue&type=script&lang=js"

import "./app-layout-setting.vue?vue&type=style&index=0&id=ca270332&lang=less"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__